<div class="ts-tree-menu" [ngClass]="{ 'p-0': suppressHeader }">
  <div class="ts-tree-menu__loading" *ngIf="loading">
    <div class="ph-col-12">
      <div class="ph-row">
        <div class="ph-col-12"></div>

        <div class="ph-col-2 empty"></div>
        <div class="ph-col-10"></div>

        <div class="ph-col-2 empty"></div>
        <div class="ph-col-10"></div>

        <div class="ph-col-2 empty"></div>
        <div class="ph-col-10"></div>

        <div class="ph-col-2 empty"></div>
        <div class="ph-col-10"></div>
      </div>
    </div>

    @if (!smallSkeleton()) {
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-12"></div>

          <div class="ph-col-2 empty"></div>
          <div class="ph-col-10"></div>

          <div class="ph-col-2 empty"></div>
          <div class="ph-col-10"></div>

          <div class="ph-col-2 empty"></div>
          <div class="ph-col-10"></div>

          <div class="ph-col-2 empty"></div>
          <div class="ph-col-10"></div>
        </div>
      </div>
    }
  </div>

  <div class="ts-tree-menu__header" *ngIf="!loading && !suppressHeader">
    <div class="ts-tree-menu__header__title" [class.title-icon]="!!titleIcon">
      @if (titleIcon) {
        <ts-icon [icon]="titleIcon" size="small"></ts-icon>
      }
      {{ title }}
    </div>
    <div class="ts-tree-menu__header__actions">
      <button
        *ngFor="let action of actions"
        (click)="onActionClicked(action)"
        [matTooltip]="action.label"
        [disabled]="action.disabled"
      >
        <ts-icon [icon]="action.icon || 'add'" [outlined]="true"></ts-icon>
      </button>
    </div>
  </div>
  <mat-tree
    [dataSource]="dataSource"
    [treeControl]="treeControl"
    class="ts-tree-menu__tree"
    [class.ml-2]="extraMarginLeft"
    *ngIf="!loading"
  >
    <!-- leaf nodes -->
    <mat-tree-node
      *matTreeNodeDef="let node"
      (click)="leafItemClicked(node)"
      matTreeNodePadding
      matTreeNodePaddingIndent="20px"
      [attr.data-testid]="getDataTestId(node)"
    >
      <div
        class="ts-tree-menu__list-item"
        [class.ts-tree-menu__list-item--active]="isLeafItemActive(node)"
        [class.ts-tree-menu__list-item--disabled]="isLeafItemDisabled(node)"
      >
        <button class="ts-tree-menu__list-item__button" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <ts-icon [outlined]="true" [icon]="node.icon || 'folder'"></ts-icon>
        </button>
        <div class="ts-tree-menu__list-item-label">
          <span [title]="node.name">
            {{ node.name }}
          </span>
          <div class="ts-tree-menu__list-item__trailing">
            <ng-container *ngIf="node.badge?.value">
              <ts-badge [value]="node.badge?.value" [type]="node.badge?.type"></ts-badge>
            </ng-container>
            <ng-container *ngIf="node.statusIcon">
              <ts-icon
                class="ts-tree-menu__list-item__status-icon"
                [ngClass]="node.statusIcon.cssClass"
                [icon]="node.statusIcon.icon"
                size="small"
              ></ts-icon>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-tree-node>

    <!-- expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20px">
      <div
        class="ts-tree-menu__list-item ts-tree-menu__list-item--has-child"
        [class.ts-tree-menu__list-item--expanded]="node.level === 0 && treeControl.isExpanded(node)"
      >
        <button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        <div matTreeNodeToggle [title]="node.name">
          {{ node.name }}
        </div>
      </div>
    </mat-tree-node>

    <!-- ACTION NODE -->
    <mat-tree-node
      *matTreeNodeDef="let node; when: isActionButton"
      (click)="leaftActionItemClicked(node)"
      matTreeNodePadding
      matTreeNodePaddingIndent="20px"
    >
      <div class="ts-tree-menu__list-item ts-tree-menu__list-item--button">
        <button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="material-icons-outlined">{{ node.icon || 'add' }}</mat-icon>
        </button>
        <div class="ts-tree-menu__list-item-label">
          <span>{{ node.action.label }}</span>
        </div>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
